import type { Dispatch, Middleware, MiddlewareAPI } from './useEnhancedReducer';
import type { BaseAction } from '../reducer/types';

export interface ThunkDispatch<A extends BaseAction, S> {
  <T extends A>(action: T): T;
  <R>(action: ThunkAction<A, S, R>): R;
}

export type ThunkAction<A extends BaseAction, S, R> = (
  dispatch: ThunkDispatch<A, S>,
  getState: () => S,
) => R;

// eslint-disable-next-line @typescript-eslint/ban-types
export type ThunkMiddleware<S = {}, A extends BaseAction = BaseAction> = Middleware<
  S,
  A,
  ThunkDispatch<A, S>
>;

export const thunkMiddleware =
  <A extends BaseAction, S>({ dispatch, getState }: MiddlewareAPI<S, Dispatch<A>>) =>
  (next: Dispatch<A>) =>
  <R>(action: ThunkAction<BaseAction, S, R>): R => {
    if (typeof action === 'function') {
      return action(dispatch, getState);
    }

    return next(action);
  };
